import { createBrowserRouter } from "react-router";
import { AppShell } from "@/components/shell/AppShell";
import { LoginPage } from "@/features/auth/LoginPage";
import { SelectTenantPage } from "@/features/auth/SelectTenantPage";
import { TodayPage } from "@/features/today/TodayPage";
import { OFFICE_ROLES } from "@/lib/auth";
import { HomeRedirect, RequireLogin, RequireRole, RequireSession } from "./guards";

// Selten genutzte Seiten werden erst bei Bedarf geladen (ExcelJS hängt am Monatsabschluss).
const lazyPage = (load: () => Promise<{ Component: React.ComponentType }>) => ({ lazy: load });

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  { element: <RequireLogin />, children: [{ path: "/select-tenant", element: <SelectTenantPage /> }] },
  {
    element: <RequireSession />,
    children: [
      { path: "/", element: <HomeRedirect /> },
      {
        path: "/app",
        element: (
          <RequireRole roles={OFFICE_ROLES}>
            <AppShell />
          </RequireRole>
        ),
        children: [
          { index: true, element: <TodayPage /> },
          { path: "times", ...lazyPage(() => import("@/features/times/TimesPage").then((m) => ({ Component: m.TimesPage }))) },
          { path: "accounts", ...lazyPage(() => import("@/features/accounts/AccountsPage").then((m) => ({ Component: m.AccountsPage }))) },
          { path: "absences", ...lazyPage(() => import("@/features/absences/AbsencesPage").then((m) => ({ Component: m.AbsencesPage }))) },
          { path: "payroll", ...lazyPage(() => import("@/features/payroll/PayrollPage").then((m) => ({ Component: m.PayrollPage }))) },
          { path: "employees", ...lazyPage(() => import("@/features/employees/EmployeesPage").then((m) => ({ Component: m.EmployeesPage }))) },
          { path: "settings", ...lazyPage(() => import("@/features/settings/SettingsPage").then((m) => ({ Component: m.SettingsPage }))) },
        ],
      },
      { path: "/me/*", ...lazyPage(() => import("@/features/me/MeApp").then((m) => ({ Component: m.MeApp }))) },
    ],
  },
  { path: "*", element: <HomeRedirect /> },
]);
